import { createStyles, makeStyles } from '@material-ui/core';

import AuthDots from '../../../assets/images/bg/Auth_bg_dots.svg';
import AuthLines from '../../../assets/images/bg/Auth_bg_lines.svg';

import { colorVariables } from '../../../styles/colorVariables';
import { Sizes } from '../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      flex: 1,
      minHeight: '100vh',
      height: '100%',
      padding: '50px 80px 20px 80px',
      position: 'relative',
      backgroundColor: 'rgba(207, 215, 230, 0.3)',
      background: 'linear-gradient rgba(255, 255, 255, 1) 100%, rgba(255, 255, 255, 0) 0%)',
      backgroundImage: `url(${AuthLines}), url(${AuthDots})`,
      backgroundRepeat: 'no-repeat, no-repeat',
      backgroundPosition: 'top 126px left 0px, bottom 250px right 0px',
      [theme.breakpoints.down(Sizes.desktop)]: {
        overflowY: 'scroll',
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        backgroundPosition: 'top 60px left 0px, bottom 60px right 0px',
        padding: 20,
      },
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: 30,
      [theme.breakpoints.down(Sizes.desktop)]: {
        paddingTop: 10,
      },
      [theme.breakpoints.down(Sizes.tablet)]: {
        paddingTop: 40,
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        paddingTop: 60,
      },
    },
    logoBox: {
      position: 'absolute',
      top: 33,
      left: '50%',
      transform: 'translateX(-50%)',
      [theme.breakpoints.down(Sizes.desktop)]: {
        top: 15,
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        top: 20,
      },
    },
    logo: {
      width: 178,
      height: 34,
    },
    progressWrap: {
      width: 260,
      marginBottom: 40,
      [theme.breakpoints.down(Sizes.desktop)]: {
        marginBottom: 20,
      },
      [theme.breakpoints.down(Sizes.tablet)]: {
        marginBottom: 20,
      },
    },
    title: {
      fontSize: 40,
      lineHeight: '50px',
      fontWeight: 700,
      marginBottom: 20,
      textAlign: 'center',
      [theme.breakpoints.down(Sizes.desktop)]: {
        fontSize: 36,
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 30,
        lineHeight: '40px',
        padding: '0 15px',
      },
    },
    subTitle: {
      opacity: 0.7,
      marginBottom: 25,
      textAlign: 'center',
      lineHeight: '28px',
      [theme.breakpoints.down(Sizes.desktop)]: {
        marginBottom: 20,
      },
      [theme.breakpoints.down(Sizes.tablet)]: {
        marginBottom: 30,
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        padding: '0 30px',
      },
    },
    boldText: {
      fontWeight: 700,
    },
    btnBox: {
      display: 'flex',
      marginTop: 30,
      '&>button': {
        margin: '0 12px',
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        flexDirection: 'column-reverse',
        '&>button': {
          margin: 0,
          marginBottom: 15,
        },
      },
    },
    btnBoxSuppliers: {
      [theme.breakpoints.down(Sizes.mobile)]: {
        flexDirection: 'row',
        marginBottom: 10,
        '&>button': {
          margin: '0 10px',
          height: 36,
        },
      },
    },
    notFoundText: {
      marginTop: 10,
      marginBottom: 20,
      cursor: 'pointer',
      width: '100%',
      textAlign: 'center',
      '&:hover': {
        color: colorVariables.blue,
        [theme.breakpoints.down(Sizes.mobile)]: {
          color: 'inherit',
        },
      },
    },
    fieldWrap: {
      width: 325,
      marginBottom: 15,
      [theme.breakpoints.down(Sizes.desktop)]: {
        marginBottom: 10,
      },
    },
    smallFieldsBox: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      marginBottom: 20,
      width: 325,
    },
    smallFieldWrap: {
      width: '48%',
      marginBottom: 15,
      [theme.breakpoints.down(Sizes.desktop)]: {
        marginBottom: 10,
      },
      [theme.breakpoints.down(Sizes.tablet)]: {
        marginBottom: 20,
      },
    },
    formBox: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    addLater: {
      width: '100%',
      textAlign: 'center',
      padding: '20px 0',
      [theme.breakpoints.down(Sizes.desktop)]: {
        paddingBottom: 40,
      },
    },

    uploadSubTitle: {
      [theme.breakpoints.down(Sizes.desktop)]: {
        lineHeight: '27px',
      },
    },
    backToAdmin: {
      position: 'fixed',
      top: 15,
      left: 20,
    },
    weekDaysBox: {
      display: 'grid',
      gridTemplateColumns: 'repeat(7, 52px)',
      columnGap: 10,
      paddingTop: 20,
      marginBottom: 30,
      [theme.breakpoints.down(Sizes.desktop)]: {
        marginBottom: 20,
      },
      [theme.breakpoints.down(Sizes.tablet)]: {
        marginBottom: 35,
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        marginBottom: 25,
        width: '100%',
        gridTemplateColumns: 'repeat(7, minmax(40px, 56px))',
        justifyContent: 'space-between',
        columnGap: 6,
      },
    },
    weekDayItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: 84,
      borderRadius: 10,
      backgroundColor: colorVariables.white,
      boxShadow: '1px 1px 15px rgba(12, 82, 112, 0.08)',
      paddingTop: 15,
      textTransform: 'uppercase',
      border: '1px solid transparent',
      cursor: 'pointer',
      '& svg': {
        color: colorVariables.steelGrey15,
      },
      [theme.breakpoints.down(Sizes.desktop)]: {
        height: 72,
        fontSize: 11,
      },
    },
    weekDayItemSelected: {
      border: `1px solid ${colorVariables.green}`,
      backgroundColor: colorVariables.greenLight,
      '& svg': {
        color: colorVariables.green,
      },
    },
    checkIcon: {
      fontSize: 22,
      marginBottom: 8,
      color: colorVariables.transparent,
      [theme.breakpoints.down(Sizes.desktop)]: {
        fontSize: 16,
      },
    },
    detailsBox: {
      marginBottom: 30,
    },
    detailsTitle: {
      fontSize: 16,
      fontWeight: 700,
      marginBottom: 8,
    },
    detailsRow: {
      display: 'grid',
      paddingTop: 10,
      gridTemplateColumns: '130px 130px 130px',
      columnGap: 20,
      '& input': {
        textAlign: 'center',
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        gridTemplateColumns: '1fr 1fr 1fr',
        columnGap: 8,
      },
    },
    detailFieldWrap: {
      width: 130,
      marginBottom: 32,
    },
    cutOffLabel: {
      fontSize: 12,
      marginBottom: 10,
      lineHeight: '16px',
      marginTop: 4,
    },
    uploadContainerWrap: {
      width: 512,
      height: 195,
      backgroundColor: colorVariables.white,
      marginBottom: 20,
      borderRadius: 27,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 30,
      [theme.breakpoints.down(Sizes.desktop)]: {
        width: 160,
        height: 160,
        padding: 0,
        position: 'relative',
        boxShadow: '2px 2px 21px 3px rgba(12, 82, 112, 0.08)',
        marginBottom: 30,
      },
    },
    uploadContainer: {
      border: '1px dashed #152144',
      borderRadius: 12,
      margin: '15px auto',
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      padding: 30,
      [theme.breakpoints.down(Sizes.desktop)]: {
        border: 'none',
        margin: 0,
      },
    },
    uploadIcon: {
      width: 60,
      height: 60,
    },
    uploadDescription: {
      fontSize: 14,
      color: colorVariables.navy,
      marginTop: 10,
      fontWeight: 700,
      textAlign: 'center',
    },
    focused: {
      border: `2px dashed ${colorVariables.green}`,
    },
    link: {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    downTemplateBtn: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      fontSize: 14,
      lineHeight: '25px',
      height: 25,
      marginBottom: 20,
    },
    formats: {
      display: 'flex',
      marginBottom: 30,
      '& div': {
        width: 75,
        height: 30,
        borderRadius: 15,
        backgroundColor: colorVariables.white,
        fontSize: 12,
        fontWeight: 700,
        lineHeight: '30px',
        textAlign: 'center',
        '&:first-child': {
          marginRight: 15,
        },
      },
    },
    topBox: {
      display: 'flex',
      width: '100%',
      marginBottom: 5,
      justifyContent: 'space-between',
    },
    uploadProgressContainer: {
      width: 885,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      marginBottom: 10,
      '&>div': {
        flexGrow: 1,
        marginLeft: 25,
      },
      [theme.breakpoints.down(Sizes.desktop)]: {
        width: 710,
      },
      [theme.breakpoints.down(Sizes.tablet)]: {
        width: 520,
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: '100%',
        '&>div': {
          flexGrow: 1,
          marginLeft: 0,
        },
      },
    },
    fileIcon: {
      width: 32,
      height: 44,
      [theme.breakpoints.down(Sizes.mobile)]: {
        display: 'none',
      },
    },
    doneIcon: {
      fontSize: 18,
      color: colorVariables.blue,
      marginBottom: -2,
    },

    error: {
      color: colorVariables.red,
    },
    errorsBlock: {
      maxWidth: 850,
      display: 'flex',
      justifyContent: 'center',
      marginBottom: 15,
      fontStyle: 'italic',
      fontSize: 12,
      fontWeight: 600,
      color: '#EA6363',
      flexGrow: 0,
      [theme.breakpoints.down(Sizes.desktop)]: {
        maxWidth: 650,
      },
      [theme.breakpoints.down(Sizes.tablet)]: {
        maxWidth: 545,
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: 'calc(100% - 45px)',
        flexShrink: 0,
      },
    },
    errorsBlockWrap: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    downloadIcon: {
      scale: 2.5,
      margin: '20px auto',
      cursor: 'pointer',
      [theme.breakpoints.down(Sizes.mobile)]: {
        scale: 4,
        marginBottom: 40,
      },
    },
    detailsSupTitle: {
      fontSize: 12,
      opacity: 0.7,
    },
    deliverySettingsT: {
      cursor: 'pointer',
      display: 'inline-block',
      minWidth: 200,
      '& svg': {
        transition: 'transform ease-in-out 0.5s',
        marginLeft: 8,
        transform: 'rotate(0deg)',
      },
    },
    deliverySettingsTExpanded: {
      '& svg': {
        transform: 'rotate(90deg)',
      },
    },
  }),
);
